export const branchName = process.env.CONTENTFUL_ENVIRONMENT_ID || "master"

export const preview = false

export const entryIds = {
  blackBanner: "3z3QgYEFzp3MZYt6qlGMgT",
  footer: "78493B7i5B8sULKtn42IlE",
  stickyFooter: "6aT86JH4iFq956a658LCBf",
}

export const contentIds = {
  skinnyBanner: "skinnyBanner",
  featuredBlogPost: "featuredBlogPosts",
  blogCategory: "blogCategory",
}
